// extracted by mini-css-extract-plugin
export default {"nav__list":"Header_nav__list__Jdn1Y","nav__logo":"Header_nav__logo__GFnTK","nav__menu":"Header_nav__menu__ZDPa0"};